var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature"},[_c('img',{attrs:{"src":_vm.image,"alt":""}}),_c('p',{staticClass:"feature-title"},[_vm._v(" "+_vm._s(_vm.feature.title)+" ")]),_vm._l((_vm.feature.items),function(item){return _c('div',{staticClass:"items"},[_c('p',[_vm._v(" "+_vm._s(item)+" ")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }